import React from "react"
import Back from "../common/back/Back"
import TeamCard from "./TeamCard"
import SEO from "../common/SEO"
import "./team.css"
// import Awrapper from "../about/Awrapper"
import "../about/about.css"

const Team = () => {
  return (
    <>
      <SEO 
        title="Our Team - Expert Education Consultants"
        description="Meet our experienced team of education consultants at WELSH EDUCATION GROUP. Professional experts dedicated to helping students achieve their international education dreams."
        keywords="education consultants, expert team, professional consultants, education experts, WELSH EDUCATION GROUP team"
        url="/team"
        structuredData={{
          "@context": "https://schema.org",
          "@type": "WebPage",
          "name": "Our Team - WELSH EDUCATION GROUP",
          "description": "Expert education consultants team",
          "url": "https://welsheducation.com/team",
          "mainEntity": {
            "@type": "EducationalOrganization",
            "name": "WELSH EDUCATION GROUP",
            "description": "Team of expert education consultants"
          }
        }}
      />
      <Back title='Team' />
      <section className='team padding'>
        <div className='container grid'>
          <TeamCard />
        </div>
      </section>
      {/* <Awrapper /> */}
    </>
  )
}

export default Team
